<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent :width="this.width">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="time"
          :label="label"
          prepend-icon="mdi-clock-outline"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-time-picker v-if="show" v-model="time" full-width>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="cancel()">Cancel</v-btn>
        <v-btn text color="primary" @click="okay()">OK</v-btn>
      </v-time-picker>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      show: false
    };
  },
  created() {},
  mounted() {},
  computed: {
    time: {
      get() {
        return this.value;
      },
      set(time) {
        this.value = time;
      },
    },
  },
  methods: {
    okay() {
      this.$emit("input", this.time);
      this.show = false;
    },
    cancel() {
      this.show = false;
    },
  },
  watch: {},
  props: {
    value: {
      type: String
    },
    label: {
      type: String,
      default: "Please pick a time",
    },
    width: {
      type: [Number, String],
      default: 300,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>